// plugins/cookieConsent.js
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

export default {
  install(Vue) {
    CookieConsent.run(
        {
            guiOptions: {
              consentModal: {
                layout: "box",
                position: "bottom right"
              }
            },
            categories: {
              necessary: {
                enabled: true,
                readOnly: true
              },
              marketing: {
                enabled: false
              }
            },
            language: {
              default: "de",
              translations: {
                de: {
                  consentModal: {
                    title: "Wir verwenden Cookies",
                    description: "Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern.",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Nur notwendige",
                    showPreferencesBtn: "Einstellungen"
                  },
                  preferencesModal: {
                    title: "Cookie-Einstellungen",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Nur notwendige",
                    savePreferencesBtn: "Einstellungen speichern",
                    closeIconLabel: "Schließen",
                    sections: [
                      {
                        title: "Notwendige Cookies",
                        description: "Diese Cookies sind für die Funktion der Website erforderlich.",
                        linkedCategory: "necessary"
                      },
                      {
                        title: "Marketing Cookies",
                        description: "Diese Cookies werden für Werbung und Tracking verwendet (z.B. Meta Pixel).",
                        linkedCategory: "marketing"
                      }
                    ]
                  }
                }
              }
            }
          }
    )
    
    Vue.prototype.$cookieConsent = CookieConsent
  }
}